import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/Panel';
import PanelHeader from 'components/Panel/components/PanelHeader';
import PanelBody from 'components/Panel/components/PanelBody';
import StatCard from 'components/Statistics/StatCard';
import ReactECharts from 'echarts-for-react';
import SkeletonBarChart from 'components/Loading/skeletonBarChart';
import { formatNumber } from 'utils/functions';

const SummaryAdminPerformance = ({
  literals = {},
  performance = null,
}) => {
  const performanceChart = {
    series: [{
      name: literals.values,
      type: 'line',
      symbol: 'none',
      data: performance?.valuesPerDay?.map(op => op.value) || [],
    }],

    tooltip: {
      trigger: 'axis', valueFormatter: v => formatNumber(v),
    },
    legend: {
      data: [literals.values],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: performance?.valuesPerDay?.map(op => op.date.substr(5, 6)) || [],
      axisLabel: { rotate: 45 },
    },
    yAxis: {
      type: 'value',
    },
  };

  return (
    <>
      <h4 className='fw-b'>{literals.performance}</h4>
      <div className='admin-summary-mentorings row mb-4'>
        <div className='col-12 col-md-4'>
          <StatCard
            title={literals.createdKpis}
            value={performance?.custom}
            loading={!performance}
          />
          <StatCard
            title={literals.usedKpis}
            value={performance?.relations}
            loading={!performance}
          />
        </div>
        <div className='col-12 col-md-8'>
          <Panel>
            <PanelHeader title={literals.lastMonthActivity} />
            <PanelBody>
              {
                !performance ? (
                  <div className='d-flex align-items-center justify-content-center'>
                    <SkeletonBarChart height='200px' />
                  </div>
                ) : (
                  <ReactECharts option={performanceChart} style={{ height: 222 }} />
                )
              }
            </PanelBody>
          </Panel>
        </div>
      </div>
    </>
  );
};

SummaryAdminPerformance.propTypes = {
  literals: PropTypes.object.isRequired,
  performance: PropTypes.object,
};

export default SummaryAdminPerformance;
